var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M.667 3h14.666v10H.667V3Z","fill":"#ECEFF1"}}),_c('path',{attrs:{"d":"M8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z","fill":"#D50000"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }